import type { DrawingAccessRole } from "@excalidraw-ms/shared";

const ROLE_LABELS: Record<DrawingAccessRole, string> = {
  editor: "Can edit",
  viewer: "Can view",
};

const HTML_ESCAPES: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (character) => HTML_ESCAPES[character]);
}

export function buildLinkHtml(url: string, drawingTitle: string, role?: DrawingAccessRole): string {
  const roleLabel = role ? ` (${ROLE_LABELS[role]})` : "";
  return `<a href="${escapeHtml(url)}">${escapeHtml(drawingTitle)}${roleLabel} &middot; Excalidraw-MS</a>`;
}

export async function copyLink(
  url: string,
  drawingTitle?: string,
  role?: DrawingAccessRole,
): Promise<void> {
  const title = drawingTitle?.trim();
  if (title && typeof ClipboardItem !== "undefined" && navigator.clipboard?.write) {
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([buildLinkHtml(url, title, role)], { type: "text/html" }),
          "text/plain": new Blob([url], { type: "text/plain" }),
        }),
      ]);
      return;
    } catch (error) {
      console.warn("[copyLink] Rich clipboard write failed; copying the plain link:", error);
    }
  }
  if (!navigator.clipboard?.writeText) {
    throw new Error("Clipboard API not available");
  }
  await navigator.clipboard.writeText(url);
}
